/**
 * @itemgo/service-delivery
 * ItemGo Service Delivery Plugin
 */

import { deliveryManifest } from "./manifest.js";
import type { PluginModule } from "@itemgo/core";
import { calculateDeliveryPricing } from "./services/pricing.js";
import { useDeliveryPricing } from "./hooks/useDeliveryPricing.js";
import { DeliveryPricingBreakdown } from "./components/DeliveryPricingBreakdown.js";

export { deliveryManifest };

export const deliveryPlugin: PluginModule = {
  manifest: deliveryManifest,
  services: {
    calculatePrice: calculateDeliveryPricing as unknown as (params: unknown) => Promise<unknown>,
  },
  hooks: {
    usePricing: useDeliveryPricing as unknown as () => unknown,
  },
  components: {
    PriceCalculator: DeliveryPricingBreakdown as unknown as React.ComponentType<unknown>,
  },
};

// Types
export type {
  DeliverySize,
  DeliverySpeed,
  DeliveryItem,
  DeliveryStop,
  DeliveryPricingConfig,
  DeliveryPricingInput,
  DeliveryPricingResult,
  DeliveryServiceData,
} from "./types.js";

// Schema
export { deliverySchema, itemTypes } from "./schema.js";
export type { DeliveryFormData } from "./schema.js";

// Services
export {
  calculateDeliveryPricing,
  formatPence,
  DEFAULT_DELIVERY_PRICING_CONFIG,
} from "./services/pricing.js";

// React Hooks
export { useDeliveryPricing } from "./hooks/useDeliveryPricing.js";

// React Components
export { DeliveryPricingBreakdown } from "./components/DeliveryPricingBreakdown.js";
